import { Validators } from "./Validator";
const { required, minLength, maxLength, checkNumber, validIndex } = Validators;
const TourRules = {
    info: {
        tourName: [required],
        tourDescription: [ required],
        tourCity: [required],
        tourCountry: [required],
        latitude: [checkNumber],
        longitude: [checkNumber],
        
    },
    tourPoster: {
        url: [required],
    },
    scenes: [minLength, maxLength],
    scene: {
        name: [required],
        description: [required],
    },
    scenePanoImage: {
        url: [required]
    },
    hotspot: {
        name: [required],
        description: [required],
        
    },
    hotspotMove: {
        sceneIndex: [validIndex],
        name: [required]
    }
    
}
export default TourRules;